module.exports = __webpack_public_path__ + "img/ic-btn-add.e93f39c8.svg";